import { QueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

const MAX_QUERY_RETRIES = 3;

/**
 * Retry network errors and 5xx responses (including the 503 a worker returns while it is still
 * loading Entra sign-in keys), but not 4xx responses, which won't change on retry.
 * failureCount starts at 0, so this keeps TanStack's default of 3 retries.
 */
export const shouldRetryQuery = (
  failureCount: number,
  error: unknown,
): boolean => {
  const status = isAxiosError(error) ? error.response?.status : undefined;
  if (status !== undefined && status < 500) {
    return false;
  }
  return failureCount < MAX_QUERY_RETRIES;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetryQuery,
    },
  },
});
